import { render, staticRenderFns } from "./SupportMonthComparison.vue?vue&type=template&id=0de72836"
import script from "./SupportMonthComparison.vue?vue&type=script&lang=js"
export * from "./SupportMonthComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports